import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { parentApi, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { GoogleButton } from "../lib/googleAuth";

export const ParentGate = ({ open, onOpenChange }) => {
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const { unlockParent, parent } = useAuth();
  const nav = useNavigate();
  const googleOnly = parent?.has_password === false;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await parentApi.post("/auth/verify-password", { password: pw });
      unlockParent();
      onOpenChange(false);
      nav("/parent");
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setBusy(false);
      setPw("");
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="parent-gate-dialog" className="border-[3px] border-[#1B1A2E] rounded-3xl shadow-[6px_6px_0_0_#1B1A2E]">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl flex items-center gap-2"><Lock size={22} /> Grown-ups only</DialogTitle>
          <DialogDescription>{googleOnly ? "Sign in with Google again to open the dashboard." : "Enter your parent password to open the dashboard."}</DialogDescription>
        </DialogHeader>
        {googleOnly ? <GoogleButton path="/parent" label="Unlock with Google" testid="parent-gate-google-btn" /> : (
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="parent-gate-password-input" type="password" className="zn-input" placeholder="Parent password" value={pw} onChange={(e) => setPw(e.target.value)} autoFocus />
          {err && <p data-testid="parent-gate-error" className="text-[#E8442A] text-sm font-semibold">{err}</p>}
          <button data-testid="parent-gate-submit" disabled={busy || !pw} className="zn-btn bg-[#7B5CFA] text-white w-full">Unlock dashboard</button>
        </form>
        )}
      </DialogContent>
    </Dialog>
  );
};
